export default "__VITE_ASSET__BoLbewcR__"